import { render, staticRenderFns } from "./NotificationBar.vue?vue&type=template&id=de74828c&scoped=true&"
import script from "./NotificationBar.vue?vue&type=script&lang=ts&"
export * from "./NotificationBar.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationBar.vue?vue&type=style&index=0&id=de74828c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de74828c",
  null
  
)

export default component.exports